import "angular";
import CommonBondDirective from "./CommonBondDirective";
import ProcessSsoDirective from "./ProcessSsoDirective";
import SamlDisclaimerDirective from "./SamlDisclaimerDirective";
import SamlTokenFactory from "./SamlTokenFactory";
import SamlTokenService from "./SamlTokenService";

const SamlTokenModule = angular
    .module("SamlTokenModule", [])
    .service("samlTokenService", SamlTokenService)
    .factory("samlTokenFactory", SamlTokenFactory)
    .directive("processSsoDirective", ProcessSsoDirective)
    .directive("samlDisclaimer", SamlDisclaimerDirective)
    .directive("commonBond", CommonBondDirective);

export default SamlTokenModule;
